<div tabindex="-1" class="layout-container" [class.no-banner]="!showBanner()">
  @if (showBanner()) {
    <app-banner> </app-banner>
  }
  <main class="page-content">
    <router-outlet></router-outlet>
  </main>
</div>
